/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	stepLocator: {
		id: 'eoc-changeboarding.wizard.step-locator-no-translate',
		defaultMessage: '{stepNumber} of {totalSteps}',
		description: 'Indicator of current step',
	},
	nextButton: {
		id: 'eoc-changeboarding.wizard.next-button-no-translate',
		defaultMessage: 'Next',
		description: 'Next button label',
	},
	backButton: {
		id: 'eoc-changeboarding.wizard.back-button-no-translate',
		defaultMessage: 'Back',
		description: 'Back button label',
	},
	closeButton: {
		id: 'eoc-changeboarding.wizard.close-button-no-translate',
		defaultMessage: 'Close',
		description: 'Close button label',
	},
	unlockButton: {
		id: 'eoc-changeboarding.wizard.unlock-button-no-translate',
		defaultMessage: 'Let’s start shifting',
		description: 'Unlock button label',
	},
	getStartedButton: {
		id: 'eoc-changeboarding.wizard.get-started-button-no-translate',
		defaultMessage: 'Open shifting guide',
		description: 'Get started button label',
	},
	remindMeLaterButton: {
		id: 'eoc-changeboarding.wizard.remind-me-later-button-no-translate',
		defaultMessage: 'Remind me later',
		description: 'Remind me later button label',
	},
});
